export default __webpack_public_path__ + "assets/mastercard-2ff51eb4342edcfb3124fb183ed81cb7.svg";